module.exports = __webpack_public_path__ + "static/media/dinosaur(25).74ceb017.PNG";